import { request } from './request'
let openid = window.openid;
const mapApi = {
    // 当前定位
    getCoordinate:()=>{
        return request({
            url: '/CoordinateInfo/GetCoordinate',
            params: {
                openid: window.openid,
                _t:new Date().getTime()
            }
        })
    },
    // 路线
    getRouteList:()=>{
        return request({
            url: '/RoutePlan/GetList',
            params: {}
        })
    },
    // 景点坐标
    getSpotList:(params)=>{
        return request({
            url: '/ScenicSpotApi/GetList',
            params: {
                ...params,
                openid:window.openid
            }
        })
    },
    // 景点详情
    getSpotById:(id)=>{
        return request({
            url: '/ScenicSpotApi/GetById',
            params: {
                id,
                openid: window.openid,
                _t:new Date().getTime()
            }
        })
    },
    // 添加点坐标 name,info
    AddPoint:(params)=>{
        return request({
            url: '/ScenicSpotApi/AddPostionInfo',
            params: {
                ...params,
                _t:new Date().getTime()
            }
        })
    },
    // 添加点坐标 name,info
    getAllPoint:(params)=>{
        return request({
            url: '/ScenicSpotApi/GetListSpotInfo',
            params: {
                ...params,
                _t:new Date().getTime()
            }
        })
    },
    // 点赞
    addLike:(scenic_id)=>{
        return request({
            url: '/ScenicSpotApi/AddLike',
            params: {
                scenic_id,
                openid: window.openid,
            }
        })
    },
    // 取消点赞
    deleteLike:(scenic_id)=>{
        return request({
            url: '/ScenicSpotApi/DeleteLike',
            params: {
                scenic_id,
                openid: window.openid,
            }
        })
    },
    // 景点打卡人数
    getSumCount:(scenic_id)=>{
        return request({
            url: '/Clockin/GetSumCount',
            params: {
                scenic_id: scenic_id,
            }
        })
    },
}

export default mapApi